import type { FC } from "react";

import { MultiTab } from "@jti/ui/components/MultiTab";

import type { informationAboutProductsInputs } from "./InformationAboutProducts.builder";

export type InformationAboutProductsBuilderProps = BuilderComponentProps<typeof informationAboutProductsInputs>;

export const InformationAboutProducts: FC<InformationAboutProductsBuilderProps> = ({
  title,
  bottomDescription,
  tabList,
  multiTabVariant,
  ctaText,
  ctaHref,
}) => {
  return (
    <MultiTab
      title={title}
      bottomDescription={bottomDescription}
      tabList={tabList}
      multiTabVariant={multiTabVariant}
      ctaText={ctaText}
      ctaHref={ctaHref}
    />
  );
};
